import { Component, effect, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { COUNTRY_CODE } from '@core/enums';

@Component({
  selector: 'agenda-customer-ui-card-address',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-address.component.html',
  styleUrls: ['./card-address.component.scss']
})
export class CardAddressComponent  {
  address = input.required<string>();
  city = input.required<string>();
  state = input.required<string>();
  country = input.required<string>();
  postalCode = input.required<string>();

  showPostalCode = false;
  fullAddress?: string;

  constructor() {
    effect(() => {
      this.showPostalCode = this.#showPostalCode();
      this.fullAddress = this.#getAddressString();
    });
  }

  #showPostalCode = (): boolean => this.country() === COUNTRY_CODE.BRAZIL;

  #getAddressString = (): string => {
    const addressParts = [];

    if (this.city) {
      addressParts.push(this.city());
    }

    if (this.state) {
      addressParts.push(this.state());
    }

    if (this.showPostalCode && this.postalCode()) {
      addressParts.push(this.postalCode());
    }

    return addressParts.join(', ');
  }

}
